<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="cols" class="d-flex align-center">
        <canvas :id="id" height="350"></canvas>
        <div class="logo"><v-img :src="require(`@/assets/img/${ $vuetify.theme.dark ? 'driblab_white.png': 'driblab_color.png' }`)" max-width="125px"></v-img></div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      barChart: null,
    };
  },
  props:{
    id:{
      type: String,
      required: true
    },
    datasets:{
      type: Array,
      default: () => null,
    },
    xAxisLabels:{
      type: Array,
      default: () => [],
      required: true
    },
    options: {
      type: Object,
      default: () => null,
    },
    cols: {
      type: String,
      default: '12'
    },
    printNumbers: {
      type:Boolean,
      default:false
    },
    noDataText: {
      type: String,
      default: "No Data"
    },
    // Optional crest URLs per bar (used only by some charts)
    crestUrls: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
     this.generateChart();
  },
  watch: {
    id(newId, oldId){
      this.updateChart();
    },
    datasets(newDataSet, oldDataSet){
      this.updateChart();
    },
    xAxisLabels(newLabels,oldLabels){
      this.updateChart();
    },
    crestUrls() {
      this.updateChart();
    }
  },
  methods: {
    generateChart() {
      var ctx = document.getElementById(this.id).getContext("2d");
      var printNumbers = this.printNumbers;
      var noDataText = this.noDataText;
      var imageCache = {};
      // Allow per-chart tweaks without touching global options
      let options = this.options || {};
      if (this.id === 'playerScoutChart') {
        const baseLayout = (options && options.layout) || {};
        const basePadding = baseLayout.padding || {};
        const baseScales = options.scales || {};
        const baseXAxes = baseScales.xAxes || [{}];

        options = {
          ...options,
          layout: {
            ...baseLayout,
            padding: {
              ...basePadding,
              top: 5,
              bottom: 40
            }
          },
          scales: {
            ...baseScales,
            xAxes: baseXAxes.map((ax, idx) =>
              idx === 0
                ? {
                    ...ax,
                    ticks: {
                      ...(ax.ticks || {}),
                      maxRotation: 60,
                      minRotation: 40,
                      autoSkip: false
                    }
                  }
                : ax
            )
          }
        };
      }

      this.barChart = new Chart(ctx, {
          type: 'bar',
          data: {
              title: this.title,
              labels: this.xAxisLabels,
              datasets: this.datasets,
              crestUrls: this.crestUrls || [],
          },
          options,
          plugins: [{
            afterDraw: function(chart) {
              //Print number over bars
              if(printNumbers){
                chart.config.data.datasets.forEach(dataset => {
                  dataset.data.forEach((value, idx) => {
                    if(value > 0){
                      let x = Object.values(dataset._meta)[0].data[idx]._model.x;
                      let y = Object.values(dataset._meta)[0].data[idx]._model.y - 10;
                      ctx.font = "bold 12pt NeueMontreal";
                      ctx.textAlign = 'center';
                      ctx.fillText(value, x, y);
                    }
                  });
                });
              }
              
              var printChart = false;
              chart.config.data.datasets.forEach(dataset => {
                dataset.data.forEach((value, idx) => {
                    if(value > 0){
                      printChart = true;
                    }
                  });
              });
              
              if (!printChart) {
                // No data is present, all datasets of the chart are empty
                var width = chart.chart.width;
                var height = chart.chart.height
                //Remove chart
                chart.clear();
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = "bold 36px 'NeueMontreal'";
                ctx.fillStyle = "rgba(190, 190, 190, 0.5)";
                ctx.fillText(noDataText, width/2, height/2);
                ctx.restore();
              }

              // Draw crests above each bar if crestUrls provided
              var crestUrls = chart.config.data.crestUrls || [];
              if (crestUrls && crestUrls.length) {
                chart.config.data.datasets.forEach(dataset => {
                  const meta = Object.values(dataset._meta || {})[0];
                  if (!meta || !meta.data) return;
                  meta.data.forEach((bar, idx) => {
                    const url = crestUrls[idx];
                    if (!url) return;

                    if (!imageCache[url]) {
                      const img = new Image();
                      img.src = url;
                      imageCache[url] = img;
                      img.onload = () => chart.draw();
                    }

                    const img = imageCache[url];
                    if (!img || !img.complete) {
                      return;
                    }
                    const size = 20;
                    const x = bar._model.x - size / 2;
                    // Place crest slightly above bar top but clamped inside chart area
                    let y = bar._model.y - size - 6;
                    if (chart.chartArea && y < chart.chartArea.top + 2) {
                      y = chart.chartArea.top + 2;
                    }

                    ctx.save();
                    ctx.drawImage(img, x, y, size, size);
                    ctx.restore();
                  });
                });
              }
            }
          }]
      });

      //Emit when is loaded
      this.$emit("loaded", this.id);
    },
    updateChart() {
      if (!this.barChart) return;
      //Reload labels
      this.barChart.data.labels = this.xAxisLabels.slice();
      // Sync crest URLs if provided
      this.barChart.data.crestUrls = this.crestUrls || [];
      this.barChart.update();
    },
  },
};
</script>
<style>
  .logo{
    position: absolute;
    top: 86%;
    right: 3%;
  }
</style>
